import { selectOffer } from './offerData';
import { IState } from '../store';
import { getFormattedCoworkingTitle } from '../utils/getFormattedCoworkingTitle';
import { getCommercialBuildingClass, getOfferTitle, getSquareInformation } from '../utils/offer_helpers';
import { getOfferType, isCommercial } from '../utils/offer_type';

export const selectOfferTitle = (state: IState) => {
  const offer = selectOffer(state);
  const offerType = getOfferType(offer);
  const businessShoppingCenter = state.offerData.businessShoppingCenter;
  const commercialBuildingClass = getCommercialBuildingClass(offer.building, businessShoppingCenter);
  let title = getOfferTitle(offer);
  const squareInformation = getSquareInformation(offer);

  if (offer.coworkingOfferType) {
    return getFormattedCoworkingTitle({
      title,
      squareInformation,
      workplaceCount: offer.workplaceCount,
      coworkingOfferType: offer.coworkingOfferType,
    });
  }

  if (isCommercial(offerType) && commercialBuildingClass) {
    title += ` ${commercialBuildingClass}`;
  }

  if (squareInformation) {
    title += `, ${squareInformation}`;
  }

  return title;
};
